export function getStorageKey(key) {
  return import.meta.env.VITE_BRANCH + ':' + import.meta.env.VITE_NAME + ':' + key
}

const layaTokenKey = getStorageKey('layaToken')
const assetStoreTokenKey = getStorageKey('assetStoreToken')
const assetStoreUserKey = getStorageKey('assetStoreUser')
export function getLayaToken() {
  return sessionStorage.getItem(layaTokenKey)
}

export function setLayaToken(token) {
  sessionStorage.setItem(layaTokenKey, token)
}

export function getAssetStoreToken() {
  return sessionStorage.getItem(assetStoreTokenKey)
}

export function setAssetStoreToken(token) {
  sessionStorage.setItem(assetStoreTokenKey, token)
}

export function getAssetStoreUser() {
  return sessionStorage.getItem(assetStoreUserKey)
}

export function setAssetStoreUser(user) {
  sessionStorage.setItem(assetStoreUserKey, JSON.stringify(user))
}


export function removeToken() {
  sessionStorage.removeItem(layaTokenKey)
  sessionStorage.removeItem(assetStoreTokenKey)
  sessionStorage.removeItem(assetStoreUserKey)

}
